module.exports = __webpack_public_path__ + "0a0fd6accde3cf8d20e98d8992bab4f5.png";